import { Action, createReducer, on } from '@ngrx/store';
import { CustomerAccount } from '@dch/common-business-logic';
import {
  getCustomerAccountFailure,
  getCustomerAccountRequest,
  getCustomerAccountSuccess,
  setCustomerLanguage,
} from '../actions/customer.actions';

export interface CustomerAccountState {
  customerAccount?: CustomerAccount;
  language: 'en' | 'fr' | 'nl' | 'de';
  hasError: boolean;
  isFetching: boolean;
}

export const initialState: CustomerAccountState = {
  customerAccount: undefined,
  language: 'fr',
  hasError: false,
  isFetching: false,
};

export const customerAccountReducer = createReducer(
  initialState,
  on(setCustomerLanguage, (state, { language }) => ({
    ...state,
    language,
  })),
  on(getCustomerAccountRequest, (state) => ({
    ...state,
    hasError: false,
    isFetching: true,
  })),
  on(getCustomerAccountSuccess, (state, { customerAccount }) => ({
    ...state,
    customerAccount,
    isFetching: false,
  })),
  on(getCustomerAccountFailure, (state) => ({
    ...state,
    hasError: true,
    isFetching: false,
  }))
);
